import { Component, OnInit } from '@angular/core';
import { ReportingYear } from 'src/app/classes/reportingData';
import { YearService } from 'src/app/services/year.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { accordeonMe } from 'src/app/animations';


@Component({
	selector: 'app-year-management',
	templateUrl: './year-management.component.html',
	styleUrls: [ './management-interface.css', 'accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class YearManagementComponent implements OnInit {


	elements: ReportingYear[] = [];
	currentFilter = "";
	filteredElements: ReportingYear[] = [];
	expandedElementId = "";

	sortingField = 'bjJahr';
	sortingAsc = true;

	bLoading = true;
	subscriptions = new Subscription();


	constructor(
		private yearService: YearService,
		private matDialog: MatDialog
	) {}


	ngOnInit() {

		this.yearService.getAll().subscribe( years => {
			this.bLoading = false;
			this.elements = years;
			this.sortElements();
		});

	}


	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a[this.sortingField] || '').toString();
			const valueB = (b[this.sortingField] || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			for( const searchField of [ "bjJahr", "bjVon", "bjBis", "bjAnpassungsfaktorVGV" ] ) {

				if( !u[ searchField ] ) continue;
				const str = ("" + u[ searchField ]).toLowerCase();
				if( str.includes( this.currentFilter ) ) return true;

			}

			return false;

		});

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}

	showCreationDialog() {

		this.matDialog.open( YearCreatorDialog, { maxHeight: '90vh' }).afterClosed().subscribe( (element: ReportingYear) => {
			if( element && element.bjJahr ) {
				this.elements.push( element );
				this.sortElements();
			}
		});
	}

}



@Component( {
	selector: 'year-creator-dialog',
	template: `
		<app-year-editor
			[bCreation]="true"
			(done)="creationDone($event)"
		/>
	`
})
export class YearCreatorDialog {
	constructor(
		public dialogRef: MatDialogRef<YearCreatorDialog>,
	) {}

	creationDone( element: ReportingYear ) {
		this.dialogRef.close( element );
	}
}
